import { render, staticRenderFns } from "./DepositReturnModal.vue?vue&type=template&id=126e066c&scoped=true"
import script from "./DepositReturnModal.vue?vue&type=script&lang=js"
export * from "./DepositReturnModal.vue?vue&type=script&lang=js"
import style0 from "./DepositReturnModal.vue?vue&type=style&index=0&id=126e066c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126e066c",
  null
  
)

export default component.exports